export function isCustomer() {
    const token = localStorage.getItem('accessToken');
    const customerId = localStorage.getItem('customerId');
    return { isCustomerUser: Boolean(token && customerId), customerId };
}

// Helper to build authentication headers for voucher requests
export function buildAuthHeaders(isCustomer) {
    const headers = {};

    // staff session (if present)
    const sessionId = localStorage.getItem('x-session-id') || localStorage.getItem('sessionId');
    if (sessionId) headers['x-session-id'] = sessionId;

    // customer CAC (only on /customer/*)
    if (isCustomer) {
        let raw = localStorage.getItem('accessToken') || '';
        if (raw.startsWith('Bearer ')) raw = raw.slice(7); // strip "Bearer "
        if (raw.startsWith('shcat_')) headers.Authorization = raw; // send raw shcat_ token
    }

    return headers;
}
